export default "__VITE_ASSET__CSoB3Lws__"